import { render } from "./LabelOrganizeView.vue?vue&type=template&id=6601e3b6&scoped=true"
import script from "./LabelOrganizeView.vue?vue&type=script&lang=js"
export * from "./LabelOrganizeView.vue?vue&type=script&lang=js"

import "./LabelOrganizeView.vue?vue&type=style&index=0&id=6601e3b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6601e3b6"]])

export default __exports__